/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from 'react'
import { Link } from 'react-router-dom'
import { useAuth } from '../../../../app/modules/auth'
import clsx from 'clsx'

const HeaderUserMenu: FC = () => {
  const { currentUser, logout, auth } = useAuth()
  const companyLogo = auth?.empresa?.s_logo_url
  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px'
      data-kt-menu='true'
    >
      <div className='menu-item px-3'>
        <div className='menu-content d-flex align-items-center px-3'>
          <div className='symbol symbol-circle symbol-50px overflow-hidden me-3'>
            <div
              className={clsx(
                'symbol-label fs-3',
                // `bg-light-${user.initials?.state}`,
                // `text-${user.initials?.state}`
              )}
            >
             {companyLogo ? (
              <img src={companyLogo} alt='Logo' className='h-50px overflow-hidden'/>
             ):  currentUser?.s_nome?.split("")?.[0]}
            </div>
          </div>

          <div className='d-flex flex-column'>
            <div className='fw-bolder d-flex align-items-center fs-5 text-truncate' style={{width: '100%'}}>
              {currentUser?.s_nome?.split('@')[0]}
              {/* <span className='badge badge-light-success fw-bolder fs-8 px-2 py-1 ms-2'>Pro</span> */}
            </div>
            <a href='#' className='fw-bold text-muted text-hover-primary fs-7'>
              {currentUser?.s_email}
            </a>
          </div>
        </div>
      </div>

      <div className='separator my-2'></div>

      {/* <Languages /> */}

      <div className='menu-item px-5 my-1'>
        <Link to='/empresa' className='menu-link px-5'>
          Configurações
        </Link>
      </div>

      <div className='menu-item px-5'>
        <a onClick={logout} className='menu-link px-5'>
          Sair
        </a>
      </div>
    </div>
  )
}

export { HeaderUserMenu }
